export default "__VITE_ASSET__97aa1169__"